
// gets bucket, key, fileName, fileExtension from s3 uri
function parseS3Uri(s3Uri) {
    if (typeof s3Uri !== "string" || !s3Uri.startsWith("s3://")) {
      throw new Error("Invalid S3 URI");
    }
  
    const withoutScheme = s3Uri.slice(5);
  
    const firstSlashIndex = withoutScheme.indexOf("/");
    if (firstSlashIndex === -1) {
      throw new Error("Invalid S3 URI: missing key");
    }
  
    const bucket = withoutScheme.slice(0, firstSlashIndex);
    const key = withoutScheme.slice(firstSlashIndex + 1);
  
    const keyParts = key.split("/");
    const fileName = keyParts.at(-1);
  
    const dotIndex = fileName.lastIndexOf(".");
    const fileExtension = dotIndex !== -1 ? fileName.slice(dotIndex + 1) : null;

    return {
      bucket,
      key,
      fileName,
      fileExtension,
    };
  }

  export default {
    parseS3Uri
  }
  